import * as React from 'react';
import {
    ApiBasedataAutoSuggest,
    ApiBasedataList,
    BasedataEntry,
    BasedataEntryParams,
    BasedataParams,
    BaseDataTagsAutoSuggestListResult,
    ServerResponse
} from '../../api';
import FAIcon from '../fAIcon/FAIcon';
import LiveSearchInput from '../liveSearchInput/LiveSearchInput';
import './CPCourseBaseDataTags.css';

export interface CPCourseBaseDataTagsProps {
    id?: string;
    courseBaseDataArray: number[];
    className?: string;
    onChangeHandler: (baseDataIdArray: number[], str: string) => void;
}

export interface CPCourseBaseDataTagsState {
    baseData: BasedataParams;
    baseDataIdArray: number[];
    deletBoxs: boolean[];
    courseBaseData: BasedataEntryParams[];
}

export default class CPCourseBaseDataTags extends React.PureComponent<
    CPCourseBaseDataTagsProps,
    CPCourseBaseDataTagsState
> {
    constructor(props: CPCourseBaseDataTagsProps) {
        super(props);
        this.state = {
            baseData: { Data: [], Key: '', Name: '' },
            baseDataIdArray: [],
            courseBaseData: [],
            deletBoxs: []
        };
    }

    public componentWillMount() {
        const deletMe: boolean[] = [];
        const baseDataIdArrayMe: number[] = this.props.courseBaseDataArray;
        let myBaseData: BasedataParams = { Data: [], Key: '', Name: '' };
        const myBaseDataFromCourse: BasedataEntryParams[] = [];
        ApiBasedataList(sr => {
            if (sr.OK && sr.Data) {
                sr.Data.Basedata.map((s: BasedataParams) => {
                    if (s.Key === 'tags') {
                        myBaseData = s;
                    }
                    myBaseData.Data.sort(this.orderData).map((d: BasedataEntry, i: number) => {
                        deletMe.push(true);
                        baseDataIdArrayMe.map((n: number) => {
                            if (d.ID === n) {
                                if (myBaseDataFromCourse.indexOf(d) < 0) {
                                    myBaseDataFromCourse.push(d);
                                    deletMe[i] = false;
                                }
                            }
                        });
                    });
                });
                this.setState(prevState => {
                    return {
                        ...prevState,
                        baseData: { ...myBaseData },
                        baseDataIdArray: [...baseDataIdArrayMe],
                        courseBaseData: [...myBaseDataFromCourse],
                        deletBoxs: [...deletMe]
                    };
                });
            }
        });
    }

    public render() {
        return (
            <>
                <LiveSearchInput
                    placeholder="Schlagwörter suchen..."
                    onFetchRequest={(search, callback) => {
                        ApiBasedataAutoSuggest(
                            {
                                Search: search
                            },
                            (sr: ServerResponse & { Data: BaseDataTagsAutoSuggestListResult }) => {
                                if (sr.OK) {
                                    callback(sr.Data.TagsData);
                                } else {
                                    callback([]);
                                }
                            }
                        );
                    }}
                    onClear={() => {
                        //
                    }}
                    renderSuggestion={(suggestion: BasedataEntry) => {
                        return <span>{suggestion.Content}</span>;
                    }}
                    getSuggestionValue={(suggestion: BasedataEntry) => {
                        this.addToBaseData(suggestion);
                        return '';
                    }}
                />
                {this.state.courseBaseData.length > 0 &&
                    this.state.courseBaseData.sort(this.orderData).map((date: BasedataEntry) => {
                        return (
                            <span key={date.ID} className="mt-2">
                                <div className="baseData">
                                    {date.Content}
                                    <FAIcon
                                        icon="trash"
                                        onClick={() => {
                                            this.removeFromBaseData(date);
                                        }}
                                        className="ml-1 float-none"
                                    />
                                </div>
                            </span>
                        );
                    })}
            </>
        );
    }

    private removeFromBaseData = (data: BasedataEntry) => {
        const myBaseDataIdArray: number[] = this.state.baseDataIdArray.filter((n: number) => n !== data.ID);
        const myBasedataEntry: BasedataEntryParams[] = this.state.courseBaseData.filter(
            (n: BasedataEntry) => n.ID !== data.ID
        );
        this.setState(
            prevState => {
                return {
                    ...prevState,
                    baseDataIdArray: [...myBaseDataIdArray.sort()],
                    courseBaseData: [...myBasedataEntry.sort(this.orderData)]
                };
            },
            () => {
                this.props.onChangeHandler(this.state.baseDataIdArray, 'tags');
            }
        );
    };

    private addToBaseData = (data: BasedataEntry) => {
        const myBaseDataIdArray: number[] = this.state.baseDataIdArray;
        const myBasedataEntry: BasedataEntryParams[] = this.state.courseBaseData;
        if (myBaseDataIdArray.indexOf(data.ID) > -1) {
            return;
        }
        myBaseDataIdArray.push(data.ID);
        myBasedataEntry.push(data);
        this.setState(
            prevState => {
                return {
                    ...prevState,
                    baseDataIdArray: [...myBaseDataIdArray.sort()],
                    courseBaseData: [...myBasedataEntry.sort(this.orderData)]
                };
            },
            () => {
                this.props.onChangeHandler(this.state.baseDataIdArray, 'tags');
            }
        );
    };

    private orderData = (a: BasedataEntry, b: BasedataEntry) => {
        if (a.Content.toLocaleLowerCase() < b.Content.toLocaleLowerCase()) {
            return -1;
        } else if (a.Content.toLocaleLowerCase() > b.Content.toLocaleLowerCase()) {
            return 1;
        }
        return 0;
    };
}



// WEBPACK FOOTER //
// ./src/components/cpCoursesTableBox/CPCourseBaseDataTags.tsx